// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3ylVm","title":"styles_title__3luUx"};